<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<p class="alignment-block-content alignment-block-content-center dedication-content"><b><i>For Andy,  You bring me <span class="last-word">sunshine</span>.</i></b></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1298154d